import { Container } from "../components/Container";
import { Skeleton } from "../components/Skeleton";
import { VisuallyHidden } from "../components/VisuallyHidden";
import styles from "./screens.module.css";
import pending from "./SessionPendingScreen.module.css";

/**
 * The wait.
 *
 * One wait, said once: asking core whether this browser already has a session. The second
 * wait this screen used to name — spending a management link — went with the link itself
 * (canon decision `D-008`). Sign-in now happens between page loads, in the browser's own
 * address bar, so there is no in-app moment left to narrate.
 *
 * One accessible status message covers the region; the skeletons themselves are decorative.
 */
export function SessionPendingScreen() {
  return (
    <Container as="main" id="main" className={styles.main}>
      <div className={styles.panel} role="status" aria-busy="true">
        <VisuallyHidden>Checking your Dealbid session</VisuallyHidden>
        <div className={pending.lines}>
          <Skeleton width="60%" height="1.75rem" />
          <Skeleton width="90%" />
          <Skeleton width="75%" />
        </div>
      </div>
    </Container>
  );
}
